import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import {timer} from 'rxjs'
import {startWith, filter, tap, take, mergeMap } from 'rxjs/operators'
import loading from '../../media/loading.svg'
import _ from 'lodash'

const BaseEmailModal = (props) => {
  const title = props.modal?.details?.title
  const defaultEmail = props.modal?.details?.defaultEmail
  const defaultMessage = props.modal?.details?.defaultMessage
  const emailCC = props.modal?.details?.emailCC
  const description = props.modal?.details?.description
  const onClick = props.modal?.details?.onClick
  const request = props.modal?.details?.request
  const dataType = props.modal?.details?.dataType
  const key = props.modal?.details?.key
  const proceedText = props.modal?.details?.proceedText
    return (
      <div key={key} className='pa4 w-100 avenir dark-gray'>
        <div className='flex justify-between'>
          <div></div>
          <div className='fw7 f3 pt2'>{title}</div>
          <div className='fw7 f5 moon-gray pointer'
            onClick={e => Dispatch.nextAction('__.Modal.close')}
            >X</div>
        </div>
        <div className='w-100 pt3 flex justify-center tc f5'>{description}</div>
        <div className='w-100 pt4 flex justify-center '>
          <div className=' pt2 fw6 tr' style={{width:75}}>To: </div>
          <div className='w-100 pl3'>
            <input 
              id='modalEmails'
              className={'w-100 pa2 ba b--moon-gray br2 bg-white fw4 '}
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              placeholder='Email'
              defaultValue={defaultEmail}
              //onChange={e => Dispatch.nextAction('shipments.set', {id, field, value: e.target.value })}
            />
            <div className='pt1 f7 gray'>Separate email addresses using commas</div>
          </div>
        </div>
        <div className='w-100 pt3 flex '>
          <div className='w3' >
            <div className='pt2 fw6 tr' style={{width:75}} >Message: </div>
            <div className='pt1 fw6 f7 gray tc' >(optional)</div>
          </div>
          <div className='w-100 pl3'>
            <textarea id='modalMessage'  
              style={{ outline: 'none', borderStyle: 'solid', resize:'none' }}  
              className={'w-100 h4 pa2 ba b--moon-gray br2 bg-white fw4 '} 
              cols={41}
              defaultValue={defaultMessage}>
       
            </textarea>
          </div>
        </div>
        <div className='w-100 pt4 tc fw6 f6'>A copy will also be CCed to ({emailCC})</div>
        <div className='w-100 pt4 flex justify-center'>
          <div className='pa3 ph4 br2 bg-moon-gray white fw6 pointer'
            onClick={e => Dispatch.nextAction('__.Modal.close')}
            >Cancel</div>
          <SubmitButton id={'save'} className='' 
            responseId='save'
            defaultChild={ props => (
              <div className='pa3 ph4 ml3 br2 bg-evonik-purple white fw6 pointer'
                onClick={e => onClick(e, {toAddress: document.getElementById('modalEmails').value, message: document.getElementById('modalMessage').value })}>
                  {proceedText ?? 'Send' }
              </div>
            )}
            loadingChild={ props => (
                <div className='mh3 flex justify-center' style={{width:45}}>
                  <img src={loading} alt='loading'/>
                </div>
            )}
            errorChild={ props => (
              <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            )}
            loadingStream={
              Dispatch.getAction('Request.' + request)
              }
            successStream={
              Dispatch.getAction('Response.' + request)
                .pipe(
                  filter(e => _.isNil(e.errors) && ((!_.isNil(e.data[dataType]) || !_.isNil(e.data[dataType]) ))),
                  mergeMap(e => timer(500,500)
                    .pipe(
                      take(1),
                      tap(e => Dispatch.nextAction('__.Modal.close')),
                      startWith('hi')
                    )
                  )
                )
              }
            errorStream={
              Dispatch.getAction('Response.' + request)
                .pipe(
                  filter(e => !_.isNil(e.errors)),
                )}
          />
        </div>
      </div>
    )
  }

export default BaseEmailModal